<template>
  <div v-if="isPageSearch" class="message-erro">
    <h1 class="icone-title">🔧</h1>
    <h1 class="title">
      Xiii... <br />
      Parece que esse manual está fora da caixa!
    </h1>
    <p class="message">
      Mas não se preocupe, tente buscar por outro nome, revisar a digitação ou
      navegar pelas nossas categorias.
    </p>
    <p class="icone-message">💡</p>
    <p class="message-sugestion">
      <b> Dica:</b> Se precisar de ajuda, nosso suporte está pronto para te
      atender!
    </p>
  </div>
  <div v-else class="message-erro">
    <h1 class="icone-title">🚧</h1>
    <h1 class="title">
      Opa... <br />
      Parece que essa página está em reforma!
    </h1>
    <p class="message">
      Essa categoria ainda não tem manuais disponíveis, mas fique tranquilo!
      Estamos sempre atualizando o portal.
    </p>
    <br />
    <p class="message-sugestion">
      Enquanto isso, que tal explorar outras categorias ou usar a busca para
      encontrar o que precisa?
    </p>
  </div>
</template>

<script setup>
const props = defineProps({
  isPageSearch: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.message-erro {
  text-align: center;
  font-family: "Ubuntu", sans-serif;
  color: #102954;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 400;
  margin: 32px 0 24px 0 !important;
  line-height: 1;
}

.message-erro .icone-title {
  font-size: 32px;
}

.message-erro .icone-message {
  font-size: 16px;
}

.message-erro .message {
  font-size: 16px;
  margin: 40px 0 0 0 !important;
}

.message-erro .message-sugestion {
  font-size: 16px;
  margin: 0 0 40px 0 !important;
}

@media (max-width: 546px) {
  .message-erro {
    margin: 32px 64px 48px 64px !important;
  }

  .message-erro .icone-title {
    font-size: 24px;
  }

  .message-erro .icone-message {
    font-size: 14px;
  }

  .message-erro .message {
    font-size: 14px;
  }

  .message-erro .message-sugestion {
    font-size: 14px;
    margin: 0 !important;
  }
}
</style>
